import { notify } from 'notiwind'

export function atsSubscriptionMiddleware(types, roles = [], option = null) {
  return function (to, from) {
    const ats = useAts()

    if (!ats.value.isSubscribed(types) || (roles.length && !ats.value.isUserRole(roles))) {
      if (import.meta.client) {
        notify({ group: 'main', type: 'danger', title: 'Accès refusé', text: 'Vous n’avez pas les droits.' })
      }
      return navigateTo({ path: '/ats' })
    }

    if (option && !ats.value.hasOption(option)) {
      return navigateTo({ path: '/ats' })
    }
  }
}
